import { Injectable } from '@angular/core';
import * as notificationsActions from './notifications.actions';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map } from 'rxjs';

@Injectable()
export class NotificationsEffects {
  constructor(private _actions$: Actions) {}

  error$ = createEffect(() =>
    this._actions$.pipe(
      ofType(notificationsActions.error),
      map((notification) =>
        notificationsActions.sended({
          ...notification,
          notificationType: 'error',
        }),
      ),
    ),
  );

  waiting$ = createEffect(() =>
    this._actions$.pipe(
      ofType(notificationsActions.waiting),
      map((notification) =>
        notificationsActions.sended({
          ...notification,
          notificationType: 'waiting',
        }),
      ),
    ),
  );

  success$ = createEffect(() =>
    this._actions$.pipe(
      ofType(notificationsActions.success),
      map((notification) =>
        notificationsActions.sended({
          ...notification,
          notificationType: 'success',
        }),
      ),
    ),
  );
}
